import { useMutation } from "@apollo/client";

import { IUserProfile } from "MVVM/@types";
import { USER_UPDATE } from "MVVM/GraphQL/user";
import { EditableBio } from "MVVM/Components/EditableBio";

export const UserBio = ({ user }: { user: IUserProfile }) => {
  const [updateUser, { loading: updateLoading }] = useMutation(USER_UPDATE, {});

  const handleSave = async (newBio: string) => {
    await updateUser({
      variables: {
        input: {
          bio: newBio,
        },
      },
    });
  };

  return (
    <EditableBio
      bioText={user.bio || ""}
      onSave={handleSave}
      isEditable={user.isOwnProfile}
      isLoading={updateLoading}
      placeholder="Add a short bio..."
      maxLength={500}
      showEmojiSelector={true}
    />
  );
};
